  <form class="form members-header-form" [formGroup]="searchForm">
    <ng-content></ng-content>
    <at-form-field label="Member's name">
      <input type="text" (input)="filterMembers()" formControlName="search" />
      <div class="icon icon-search" prefix role="presentation"></div>
    </at-form-field>
  </form>